import { useState } from "react";
import LinearLayout from "../layout/LinearLayout";
import ButtonSimp from "../button";
import { FaMinus, FaPlus } from "react-icons/fa";
import TextView from "../textview/TextView";
import { useCart } from "../../utils/CartContext";
export default function ProductRightPanel({
  price,
  discount,
  stock,
  onAddToCart,
  product,
}) {
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();
  const handleQuantityChange = (value) => {
    if (value > 0) setQuantity(value);
  };
  const getdiscount = (price, discount) => {
    const newprice = Number(price) - (Number(price) * Number(discount)) / 100;
    return newprice;
  };
  return (
    <LinearLayout
      bgcolor="white"
      padding={3}
      height="wrap-content"
      width="macth-parent"
      gap={3}
      margin={3}
      orientation="vertical"
      className="card shadow-lg"
    >
      {/* قیمت و تخفیف */}
      <LinearLayout
        padding={1}
        height="wrap-content"
        width="macth-parent"
        gap={2}
        orientation="horizontal"
        margin={1}
      >
        <TextView
          margin="0"
          color="danger"
          size="lg"
          bold={true}
          className="text-decoration-line-through"
        >
          {price.toLocaleString()}$
        </TextView>
        <TextView margin="0" color="danger" size="lg" bold={true}>
          - {getdiscount(price, discount)}$
        </TextView>
      </LinearLayout>
      <div className="m-0">
        {discount > 0 && (
          <span
            style={{
              background: "#ffccd5",
              color: "#e60023",
              padding: "2px 8px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            {discount}% discount
          </span>
        )}
      </div>

      {/* وضعیت موجودی */}
      <div style={{ fontSize: "14px", color: stock > 0 ? "green" : "red" }}>
        {stock > 0
          ? `Available in stock (Only ${stock} left.)`
          : `non-existent`}
      </div>

      {/* انتخاب تعداد */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <ButtonSimp
          color="danger"
          padding="3"
          paddingtop="0"
          paddingbottom="1"
          paddingstart="2"
          paddingend="2"
          text={<FaMinus />}
          font="6"
          size="md"
          clicked={() => handleQuantityChange(quantity - 1)}
        ></ButtonSimp>

        <span className="fs-4">{quantity}</span>
        <ButtonSimp
          color="success"
          padding="3"
          paddingtop="0"
          paddingbottom="1"
          paddingstart="2"
          paddingend="2"
          text={<FaPlus />}
          font="6"
          size="md"
          clicked={() => handleQuantityChange(quantity + 1)}
        ></ButtonSimp>
      </div>

      {/* دکمه افزودن به سبد خرید */}
      <ButtonSimp
        color="primary"
        padding="3"
        paddingtop="2"
        paddingbottom="3"
        paddingstart="4"
        paddingend="4"
        text="In my shopping cart"
        font="5"
        size="md"
        clicked={() => onAddToCart(product._id, quantity)}
      ></ButtonSimp>

      {/* ارسال رایگان */}
      <LinearLayout
        padding={3}
        height="wrap-content"
        width="macth-parent"
        gap={3}
        orientation="horizontal"
      >
        <TextView margin="1" size="sm" bold={false}>
          🚚 Free shipping on orders over $80
        </TextView>
      </LinearLayout>

      {/* پشتیبانی */}
      <div style={{ fontSize: "14px", color: "#0070f3", cursor: "pointer" }}>
        Have a question❓ Contact support❓
      </div>
    </LinearLayout>
  );
}
